import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import SummaryApi from "../common/SummaryApi";
import ProductGrid from "../components/Products/ProductGrid";

const SearchResultsPage = () => {
  const [params] = useSearchParams();
  const location = useLocation();

  const query = params.get("q");
  const imageResults = location.state?.imageResults;

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResults = async () => {
      setLoading(true);

      // 🖼 Image search results (from camera)
      if (imageResults) {
        setProducts(imageResults);
        setLoading(false);
        return;
      }

      // 🔍 Text search
      if (query) {
        try {
          const res = await axios({
            url: SummaryApi.searchText.url,
            method: SummaryApi.searchText.method,
            params: { q: query }
          });

          setProducts(res.data.products || []);
        } catch (err) {
          console.error("Search failed", err);
        }
      }

      setLoading(false);
    };

    fetchResults();
  }, [query, imageResults]);

  return (
    <div className="mx-auto px-4 lg:px-8 py-6 bg-white">
      <h2 className="text-lg font-semibold mb-4">
        {query ? `Search results for "${query}"` : "Search Results"}
      </h2>

      <ProductGrid products={products} loading={loading} />
    </div>
  );
};

export default SearchResultsPage;
